import { action, makeObservable, observable } from 'mobx'

export abstract class YardNodeViewStore<TFormData, TStore> {
  isFormDialogOpen = false
  isDeleteDialogOpen = false
  editingId?: string
  viewportCenter: { x: number; y: number } = { x: 0, y: 0 }

  protected constructor(protected readonly entityStore: TStore) {
    makeObservable(this, {
      isFormDialogOpen: observable,
      isDeleteDialogOpen: observable,
      editingId: observable,
      viewportCenter: observable,

      openFormDialog: action,
      closeFormDialog: action,
      setDeleteDialogOpen: action,
      setViewportCenter: action,
    })
  }

  setViewportCenter = (center: { x: number; y: number }) => {
    this.viewportCenter = center
  }

  openFormDialog = (id?: string) => {
    this.editingId = id
    this.isFormDialogOpen = true
  }

  closeFormDialog = () => {
    this.isFormDialogOpen = false
  }

  setDeleteDialogOpen = (id?: string) => {
    this.isDeleteDialogOpen = !!id
    this.editingId = id
  }

  abstract submit(formData: TFormData): Promise<void>

  abstract delete(id: string): Promise<void>

  abstract setPosition(id: string, position: { x: number; y: number }): void
}
